import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daysBy'
})
export class DaysPipe implements PipeTransform {

  transform(array: Array<any>, args: string): Array<any> {
    if (typeof args === 'undefined') {
        return array;
    }

  const sorter = {
      'monday': 0,
      'tuesday': 1,
      'wednesday': 2,
      'thursday': 3,
      'friday': 4,
      'saturday': 5,
      'sunday': 6
    };
    array.sort(function(a, b) {
      const day1 = a[args].toLowerCase();
      const day2 = b[args].toLowerCase();
      return sorter[day1] - sorter[day2];
    });
    return array;
}

}
